import { gql } from 'apollo-boost'

const UPDATE_SCRAPING_TAG_GROUP = gql`
  mutation updateScrapingTagGroup(
    $id: ID!
    $alias: String
    $description: String
    $tagIds: [ID!]!
  ) {
    updateScrapingTagGroup(
      id: $id
      alias: $alias
      description: $description
      tagIds: $tagIds
    )
  }
`

export default UPDATE_SCRAPING_TAG_GROUP
